/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { CompanyDimensionCountSchema } from './companyDimensionCountSchema';
import type { CompanyDimensionValueSchema } from './companyDimensionValueSchema';
import type { CompanyEmployerFlowCountSchema } from './companyEmployerFlowCountSchema';
import type { CompanyExecMoveSchema } from './companyExecMoveSchema';
import type { CompanyMetroSchema } from './companyMetroSchema';
import type { CompanyMonthlyCountSchema } from './companyMonthlyCountSchema';
import type { CompanyRateWindowSchema } from './companyRateWindowSchema';

/**
 * Vendor-sourced workforce analytics for one company.
 */
export interface CompanyWorkforceAnalyticsResponse {
  headcount_by_month?: CompanyMonthlyCountSchema[];
  gross_additions_by_month?: CompanyMonthlyCountSchema[];
  gross_departures_by_month?: CompanyMonthlyCountSchema[];
  growth_rate?: CompanyRateWindowSchema | null;
  churn_rate?: CompanyRateWindowSchema | null;
  turnover_rate?: CompanyRateWindowSchema | null;
  annualized_turnover_rate?: CompanyRateWindowSchema | null;
  headcount_by_role?: CompanyDimensionCountSchema[];
  headcount_by_class?: CompanyDimensionCountSchema[];
  average_tenure_by_role?: CompanyDimensionValueSchema[];
  median_tenure_by_role?: CompanyDimensionValueSchema[];
  top_next_employers?: CompanyEmployerFlowCountSchema[];
  top_previous_employers?: CompanyEmployerFlowCountSchema[];
  recent_exec_hires?: CompanyExecMoveSchema[];
  recent_exec_departures?: CompanyExecMoveSchema[];
  subsidiaries?: string[];
  top_us_employee_metros?: CompanyMetroSchema[];
}
